import React from 'react';
import { withTranslate } from 'react-redux-multilingual';
import { useNavigate, Link } from 'react-router-dom';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

import ParametersTableHeader from '../../Blocks/ParametersTableHeader';
import ParametersTypeValue from '../../Blocks/ParametersTypeValue';
import ReturnTypeValue from '../../Blocks/ReturnTypeValue';

function En(props) {
    const { translate } = props;
    return (
        <Box>
            <Typography variant="h5" gutterBottom id="fxtostring">
                1.&nbsp;<span className="material-symbols-outlined">function</span>&nbsp;{translate('fxtostring')}
            </Typography>
            <p><strong>{translate('fxtostring')}</strong> converts the data type of any value to return a string.</p>
            <ul style={{ listStyle: "none" }}>
                <p>
                    <strong>a.&nbsp;{translate('parameters__title')}</strong>
                </p>
                <li>
                    <table className='parameters'>
                        <ParametersTableHeader />
                        <tbody>
                            <tr>
                                <td>{translate('text')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Is any value.</td>
                                <td>123</td>
                            </tr>
                        </tbody>
                    </table>
                </li>
                <p>
                    <strong>b.&nbsp;{translate('returndatatype__title')}</strong>
                </p>
                <li>
                    <ReturnTypeValue type="text" />
                </li>
                <p>
                    <strong>c.&nbsp;{translate('example__title')}</strong>
                </p>
                <div className='results'>
                    <div>1. ToString(123) returns "123"</div>
                </div>
            </ul>
            <Typography variant="h5" gutterBottom id="fxleft">
                2.&nbsp;<span className="material-symbols-outlined">function</span>&nbsp;{translate('fxleft')}
            </Typography>
            <p><strong>{translate('fxleft')}</strong> returns the number of characters specified by <strong>{translate('numberofcharacters')}</strong>, counting from the left.</p>
            <ul style={{ listStyle: "none" }}>
                <p>
                    <strong>a.&nbsp;{translate('parameters__title')}</strong>
                </p>
                <li>
                    <table className='parameters'>
                        <ParametersTableHeader />
                        <tbody>
                            <tr>
                                <td>{translate('text')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Is any string.</td>
                                <td>"abcdefghij"</td>
                            </tr>
                            <tr>
                                <td>{translate('numberofcharacters')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="number" />
                                </td>
                                <td>Is any number.</td>
                                <td>4</td>
                            </tr>
                        </tbody>
                    </table>
                </li>
                <p>
                    <strong>b.&nbsp;{translate('returndatatype__title')}</strong>
                </p>
                <li>
                    <ReturnTypeValue type="text" />
                </li>
                <p>
                    <strong>c.&nbsp;{translate('example__title')}</strong>
                </p>
                <div className='results'>
                    <div>1. Left("abcdefghij", 4) returns "abcd"</div>
                    <div>2. Left("abcdefghij", 2) returns "ab"</div>
                </div>
            </ul>
            <Typography variant="h5" gutterBottom id="fxmiddle">
                3.&nbsp;<span className="material-symbols-outlined">function</span>&nbsp;{translate('fxmiddle')}
            </Typography>
            <p><strong>{translate('fxmiddle')}</strong> returns the number of characters specified by <strong>{translate('numberofcharacters')}</strong>, counting from the position specified by <strong>{translate('start')}</strong>.</p>
            <ul style={{ listStyle: "none" }}>
                <p>
                    <strong>a.&nbsp;{translate('parameters__title')}</strong>
                </p>
                <li>
                    <table className='parameters'>
                        <ParametersTableHeader />
                        <tbody>
                            <tr>
                                <td>{translate('text')}<span>Start*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Is any string.</td>
                                <td>"abcdefghij"</td>
                            </tr>
                            <tr>
                                <td>{translate('start')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="number" />
                                </td>
                                <td>Is any number.</td>
                                <td>5</td>
                            </tr>
                            <tr>
                                <td>{translate('numberofcharacters')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="number" />
                                </td>
                                <td>Is any number.</td>
                                <td>7</td>
                            </tr>
                        </tbody>
                    </table>
                </li>
                <p>
                    <strong>b.&nbsp;{translate('returndatatype__title')}</strong>
                </p>
                <li>
                    <ReturnTypeValue type="text" />
                </li>
                <p>
                    <strong>c.&nbsp;{translate('example__title')}</strong>
                </p>
                <div className='results'>
                    <div>1. Middle("abcdefghij", 5, 7) returns "fg"</div>
                    <div>2. Middle("abcdefghij", 2, 4) returns "cd"</div>
                </div>
            </ul>
            <Typography variant="h5" gutterBottom id="fxright">
                4.&nbsp;<span className="material-symbols-outlined">function</span>&nbsp;{translate('fxright')}
            </Typography>
            <p><strong>{translate('fxright')}</strong> returns the number of characters specified by <strong>{translate('numberofcharacters')}</strong>, counting from the right.</p>
            <ul style={{ listStyle: "none" }}>
                <p>
                    <strong>a.&nbsp;{translate('parameters__title')}</strong>
                </p>
                <li>
                    <table className='parameters'>
                        <ParametersTableHeader />
                        <tbody>
                            <tr>
                                <td>{translate('text')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Is any string.</td>
                                <td>"abcdefghij"</td>
                            </tr>
                            <tr>
                                <td>{translate('numberofcharacters')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="number" />
                                </td>
                                <td>Is any number.</td>
                                <td>4</td>
                            </tr>
                        </tbody>
                    </table>
                </li>
                <p>
                    <strong>b.&nbsp;{translate('returndatatype__title')}</strong>
                </p>
                <li>
                    <ReturnTypeValue type="text" />
                </li>
                <p>
                    <strong>c.&nbsp;{translate('example__title')}</strong>
                </p>
                <div className='results'>
                    <div>1. Right("abcdefghij", 2) returns "ij"</div>
                    <div>2. Right("abcdefghij", 5) returns "fghij"</div>
                </div>
            </ul>
            <Typography variant="h5" gutterBottom id="fxstringlength">
                5.&nbsp;<span className="material-symbols-outlined">function</span>&nbsp;{translate('fxstringlength')}
            </Typography>
            <p><strong>{translate('fxstringlength')}</strong> returns the number of characters of the string.</p>
            <ul style={{ listStyle: "none" }}>
                <p>
                    <strong>a.&nbsp;{translate('parameters__title')}</strong>
                </p>
                <li>
                    <table className='parameters'>
                        <ParametersTableHeader />
                        <tbody>
                            <tr>
                                <td>{translate('text')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Is any string.</td>
                                <td>"abcdefghij"</td>
                            </tr>
                        </tbody>
                    </table>
                </li>
                <p>
                    <strong>b.&nbsp;{translate('returndatatype__title')}</strong>
                </p>
                <li>
                    <ReturnTypeValue type="number" />
                </li>
                <p>
                    <strong>c.&nbsp;{translate('example__title')}</strong>
                </p>
                <div className='results'>
                    <div>1. StringLength("abcdefghij") returns 10</div>
                </div>
            </ul>
            <Typography variant="h5" gutterBottom id="fxtolower">
                6.&nbsp;<span className="material-symbols-outlined">function</span>&nbsp;{translate('fxtolower')}
            </Typography>
            <p><strong>{translate('fxtolower')}</strong> returns all letters in the specified text as lowercase.</p>
            <ul style={{ listStyle: "none" }}>
                <p>
                    <strong>a.&nbsp;{translate('parameters__title')}</strong>
                </p>
                <li>
                    <table className='parameters'>
                        <ParametersTableHeader />
                        <tbody>
                            <tr>
                                <td>{translate('text')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Is any string.</td>
                                <td>"ABCD"</td>
                            </tr>
                        </tbody>
                    </table>
                </li>
                <p>
                    <strong>b.&nbsp;{translate('returndatatype__title')}</strong>
                </p>
                <li>
                    <ReturnTypeValue type="text" />
                </li>
                <p>
                    <strong>c.&nbsp;{translate('example__title')}</strong>
                </p>
                <div className='results'>
                    <div>1. ToLower("ABCD", 2) returns "abcd"</div>
                    <div>2. ToLower("ABCDefghij", 5) returns "abcdefghij"</div>
                </div>
            </ul>
            <Typography variant="h5" gutterBottom id="fxtoupper">
                7.&nbsp;<span className="material-symbols-outlined">function</span>&nbsp;{translate('fxtoupper')}
            </Typography>
            <p><strong>{translate('fxtoupper')}</strong> returns all letters in the specified text as uppercase.</p>
            <ul style={{ listStyle: "none" }}>
                <p>
                    <strong>a.&nbsp;{translate('parameters__title')}</strong>
                </p>
                <li>
                    <table className='parameters'>
                        <ParametersTableHeader />
                        <tbody>
                            <tr>
                                <td>{translate('text')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Is any string.</td>
                                <td>"abcd"</td>
                            </tr>
                        </tbody>
                    </table>
                </li>
                <p>
                    <strong>b.&nbsp;{translate('returndatatype__title')}</strong>
                </p>
                <li>
                    <ReturnTypeValue type="text" />
                </li>
                <p>
                    <strong>c.&nbsp;{translate('example__title')}</strong>
                </p>
                <div className='results'>
                    <div>1. ToUpper("abcd", 2) returns "ABCD"</div>
                    <div>2. ToUpper("abcdefghij", 5) returns "ABCDEFGHIJ"</div>
                </div>
            </ul>
            <Typography variant="h5" gutterBottom id="fxpatterncount">
                8.&nbsp;<span className="material-symbols-outlined">function</span>&nbsp;{translate('fxpatterncount')}
            </Typography>
            <p><strong>{translate('fxpatterncount')}</strong> returns the number of occurrences of the search string in the text.</p>
            <ul style={{ listStyle: "none" }}>
                <p>
                    <strong>a.&nbsp;{translate('parameters__title')}</strong>
                </p>
                <li>
                    <table className='parameters'>
                        <ParametersTableHeader />
                        <tbody>
                            <tr>
                                <td>{translate('text')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Is any string.</td>
                                <td>"Mississippi"</td>
                            </tr>
                            <tr>
                                <td>{translate('searchstring')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>The string to search for.</td>
                                <td>"is"</td>
                            </tr>
                        </tbody>
                    </table>
                </li>
                <p>
                    <strong>b.&nbsp;{translate('returndatatype__title')}</strong>
                </p>
                <li>
                    <ReturnTypeValue type="number" />
                </li>
                <p>
                    <strong>c.&nbsp;{translate('example__title')}</strong>
                </p>
                <div className='results'>
                    <div>1. PatternCount("Mississippi", "is") returns 2</div>
                    <div>2. PatternCount("Mississippi", "s") returns 4</div>
                </div>
            </ul>
            <Typography variant="h5" gutterBottom id="fxsubstitute">
                9.&nbsp;<span className="material-symbols-outlined">function</span>&nbsp;{translate('fxsubstitute')}
            </Typography>
            <p><strong>{translate('fxsubstitute')}</strong> returns a text string with every occurrence of the search string in the specified text replaced with the replacement string.</p>
            <ul style={{ listStyle: "none" }}>
                <p>
                    <strong>a.&nbsp;{translate('parameters__title')}</strong>
                </p>
                <li>
                    <table className='parameters'>
                        <ParametersTableHeader />
                        <tbody>
                            <tr>
                                <td>{translate('text')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Is any string.</td>
                                <td>"abcdefghij"</td>
                            </tr>
                            <tr>
                                <td>{translate('searchstring')},{translate('replacestring')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="array" />
                                </td>
                                <td>The string to search for and the string to be replaced.</td>
                                <td>[["a", "A"]]</td>
                            </tr>
                        </tbody>
                    </table>
                </li>
                <p>
                    <strong>b.&nbsp;{translate('returndatatype__title')}</strong>
                </p>
                <li>
                    <ReturnTypeValue type="text" />
                </li>
                <p>
                    <strong>c.&nbsp;{translate('example__title')}</strong>
                </p>
                <div className='results'>
                    <div>1. Substitute("abcdefghij", [[ "a" , "A" ]]) returns "Abcdefghij"</div>
                    <div>2. Substitute("abcdefghij", [[ "ab" , "12" ]]) returns "12cdefghij"</div>
                </div>
            </ul>
            <Typography variant="h5" gutterBottom id="fxtotrim">
                10.&nbsp;<span className="material-symbols-outlined">function</span>&nbsp;{translate('fxtotrim')}
            </Typography>
            <p><strong>{translate('fxtotrim')}</strong> returns text with all leading and trailing spaces removed.</p>
            <ul style={{ listStyle: "none" }}>
                <p>
                    <strong>a.&nbsp;{translate('parameters__title')}</strong>
                </p>
                <li>
                    <table className='parameters'>
                        <ParametersTableHeader />
                        <tbody>
                            <tr>
                                <td>{translate('text')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Is any string.</td>
                                <td>" abcd "</td>
                            </tr>
                        </tbody>
                    </table>
                </li>
                <p>
                    <strong>b.&nbsp;{translate('returndatatype__title')}</strong>
                </p>
                <li>
                    <ReturnTypeValue type="text" />
                </li>
                <p>
                    <strong>c.&nbsp;{translate('example__title')}</strong>
                </p>
                <div className='results'>
                    <div>1. ToTrim(" abcd ") returns "abcd"</div>
                </div>
            </ul>
            <Typography variant="h5" gutterBottom id="fxtotrimall">
                11.&nbsp;<span className="material-symbols-outlined">function</span>&nbsp;{translate('fxtotrimall')}
            </Typography>
            <p><strong>{translate('fxtotrimall')}</strong> returns text with all spaces removed.</p>
            <ul style={{ listStyle: "none" }}>
                <p>
                    <strong>a.&nbsp;{translate('parameters__title')}</strong>
                </p>
                <li>
                    <table className='parameters'>
                        <ParametersTableHeader />
                        <tbody>
                            <tr>
                                <td>{translate('text')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Is any string.</td>
                                <td>" Julian       Scott Dunn "</td>
                            </tr>
                        </tbody>
                    </table>
                </li>
                <p>
                    <strong>b.&nbsp;{translate('returndatatype__title')}</strong>
                </p>
                <li>
                    <ReturnTypeValue type="text" />
                </li>
                <p>
                    <strong>c.&nbsp;{translate('example__title')}</strong>
                </p>
                <div className='results'>
                    <div>1. ToTrimAll(" Julian       Scott Dunn ") returns "JulianScottDunn"</div>
                </div>
            </ul>
            <Typography variant="h5" gutterBottom id="fxindexofstring">
                12.&nbsp;<span className="material-symbols-outlined">function</span>&nbsp;{translate('fxindexofstring')}
            </Typography>
            <p><strong>{translate('fxindexofstring')}</strong> returns the index of the first element in the text.</p>
            <ul style={{ listStyle: "none" }}>
                <p>
                    <strong>a.&nbsp;{translate('parameters__title')}</strong>
                </p>
                <li>
                    <table className='parameters'>
                        <ParametersTableHeader />
                        <tbody>
                            <tr>
                                <td>{translate('text')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Is any string.</td>
                                <td>"hello world"</td>
                            </tr>
                            <tr>
                                <td>{translate('searchstring')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Is the string to search for.</td>
                                <td>"lo"</td>
                            </tr>
                        </tbody>
                    </table>
                </li>
                <p>
                    <strong>b.&nbsp;{translate('returndatatype__title')}</strong>
                </p>
                <li>
                    <ReturnTypeValue type="number" />
                </li>
                <p>
                    <strong>c.&nbsp;{translate('example__title')}</strong>
                </p>
                <div className='results'>
                    <div>1. IndexOfString("hello world", "lo") returns 3</div>
                    <div>2. IndexOfString("hello world", " w") returns 5</div>
                </div>
            </ul>
            <Typography variant="h5" gutterBottom id="fxsplit">
                13.&nbsp;<span className="material-symbols-outlined">function</span>&nbsp;{translate('fxsplit')}
            </Typography>
            <p><strong>{translate('fxsplit')}</strong> returns an array of strings, split at each point where the delimiter occurs in the given string.</p>
            <ul style={{ listStyle: "none" }}>
                <p>
                    <strong>a.&nbsp;{translate('parameters__title')}</strong>
                </p>
                <li>
                    <table className='parameters'>
                        <ParametersTableHeader />
                        <tbody>
                            <tr>
                                <td>{translate('text')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Is any string.</td>
                                <td>"hello world"</td>
                            </tr>
                            <tr>
                                <td>{translate('splitwith')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>The string used to split.</td>
                                <td>" "</td>
                            </tr>
                        </tbody>
                    </table>
                </li>
                <p>
                    <strong>b.&nbsp;{translate('returndatatype__title')}</strong>
                </p>
                <li>
                    <ReturnTypeValue type="array" />
                </li>
                <p>
                    <strong>c.&nbsp;{translate('example__title')}</strong>
                </p>
                <div className='results'>
                    <div>1. IndexOfString("hello world", " ") returns ["hello", "world"]</div>
                </div>
            </ul>
            <Typography variant="h5" gutterBottom id="fxmatch">
                14.&nbsp;<span className="material-symbols-outlined">function</span>&nbsp;{translate('fxmatch')}
            </Typography>
            <p><strong>{translate('fxmatch')}</strong> returns an array of strings, which matches a string with a regular string or a regular expression.</p>
            <ul style={{ listStyle: "none" }}>
                <p>
                    <strong>a.&nbsp;{translate('parameters__title')}</strong>
                </p>
                <li>
                    <table className='parameters'>
                        <ParametersTableHeader />
                        <tbody>
                            <tr>
                                <td>{translate('text')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Is any string.</td>
                                <td>"hello world"</td>
                            </tr>
                            <tr>
                                <td>{translate('regexp')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Is a regular string or a regular expression.</td>
                                <td>"[A-Z]"</td>
                            </tr>
                        </tbody>
                    </table>
                </li>
                <p>
                    <strong>b.&nbsp;{translate('returndatatype__title')}</strong>
                </p>
                <li>
                    <ReturnTypeValue type="array" />
                </li>
                <p>
                    <strong>c.&nbsp;{translate('example__title')}</strong>
                </p>
                <div className='results'>
                    <div>1. Match("hello world", "[A-Z]") returns ["h", "e", "l", "l", "o", "w", "o", "r", "l", "d"]</div>
                </div>
            </ul>
        </Box>
    );
}
export default withTranslate(En);